import React, { useEffect } from "react";
import { updateEntry } from "features/Entries/entrySlice";
import { useDispatch, useSelector } from "react-redux";
import { SERVICE } from "constants/global";
import { ListPartner } from "components";
import { getTitleDecoration } from "utils/common";


const ModalSubmit = ({ entry, partnership, openFn, open = null }) => {
  const dispatch = useDispatch();

  const { messageUpdate, messageUpdateSuccess } = useSelector(
    (state) => state.entry
  );

  const submit = () => {
    const partnershipsList = partnership.map((item) => {
      return {
        ...item,
        partnership_id: item.id ? item.id : null,
        action: item.action == null ? 3 : item.action,
      };
    });
    dispatch(
      updateEntry({
        data: {
          service: SERVICE,
          entry_id: entry.entry_id,
          partnership: partnershipsList,
        },
        openFn,
      })
    );
  };

  useEffect(() => {
    if(messageUpdate){
      openFn("modal-update-entry");
    }
  }, [messageUpdate]);

  useEffect(() => {
    if(messageUpdateSuccess){
      openFn("modal-update-success");
    }
  }, [messageUpdateSuccess]);

  return (
    open && (
      <div className="modal active">
        <div className="modal-body">
          <div className="title mt-2">こちらの内容に、変更しますか？</div>

          <div className="box p-2 p-md-3 my-3 text-start">
            <div>
              <div
                className="d-block d-md-inline-block mb-1 mb-md-0"
                dangerouslySetInnerHTML={{
                  __html: getTitleDecoration(
                    entry?.title_decoration?.title_decoration_content
                  ),
                }}
              ></div>

              <span className="align-middle fs-14">{entry?.title_login}</span>
            </div>
            <ListPartner entry={entry} list={partnership} type={2} />
          </div>

          <div className="group-btn-modal">
            <div onClick={() => openFn("modal-partner")} className="btn-modal">
              戻る
            </div>
            <div onClick={submit} className="btn-modal red-light">
              変更する
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ModalSubmit;
